import { WithI18n } from "../../i18n";

export enum CouponType {
  SERVICE = "SERVICE",
}

export type CouponApartment = {
  id: string;
  code: string;
};

export type CouponBuilding = {
  id: string;
  code: string;
};

export type CouponService = {
  id: string;
  name: string;
};

export type CouponServiceListItem = {
  id: string;
  label: string;
};

export type CouponApartmentConsumer = {
  apartmentId: string;
  apartmentCode: string;
  userId: string;
  userFullName: string;
};

export type CouponSingleUserConsumer = {
  id: string;
  fullName: string;
};

export type CouponTargetUser = {
  id: string;
  fullName: string;
};

export type CouponReservation = {
  id: string;
  code: string;
  /**
   * Used to track how many times an apartment has used this coupon.
   */
  apartmentId?: string;
  /**
   * USed to track how many times a user has used this coupon.
   */
  userId?: string;
};

type CouponI18n = WithI18n<"description">;
export interface Coupon extends CouponI18n {
  id: string;
  type: CouponType;
  /**
   * In case buildings is specified, the coupon can be consumed once by each
   * apartment of each building.
   */
  targetBuildings?: CouponBuilding[];
  /**
   * In case apartments is specified, the coupon can be consumed once by each
   * specified apartment.
   */
  targetApartments?: CouponApartment[];
  /**
   * In case users is specified, the coupon can be consumed once by each
   * specified user.
   */
  targetUsers?: CouponTargetUser[];
  service?: CouponService;
  code: string;
  description?: string;
  discountInPercentage?: number;
  discountInPrice?: number;
  /**
   * Represents list items ids that might be used with this coupon.
   */
  listItems: CouponServiceListItem[];
  /**
   * Ids of the apartments that consumed this coupon / promo.
   * This field will be filled in case either building / apartment is specified.
   */
  consumedByApartments?: CouponApartmentConsumer[];
  /**
   * Id of the single user that consumed this coupon in case targetUser was
   * specified.
   */
  consumedByUsers?: CouponSingleUserConsumer[];
  consumedByReservations?: CouponReservation[];
  /**
   * Establishes how many times this coupon can be consumed.
   */
  maxUseCount: number;
  expireDate?: number;
  createdAt: number;
  updatedAt: number;
}
export type NewCoupon = Omit<Coupon, "id" | "createdAt" | "updatedAt"> &
  Required<Pick<Coupon, "code" | "type" | "discountInPercentage">>;
